/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019纷析云（杭州）科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月25日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
  list(accountSetsId = null) {
    return Ajax.get("/checkout", {accountSetsId})
  },
  getQccMonth(date) {
    return Ajax.get("/checkout/getQccMonth?date="+date)
  },
  last() {
    return Ajax.get("/checkout/last")
  },
  finalCheck(params) {
    return Ajax.get("/checkout/finalCheck", params)
  },
  reportCheck(params) {
    return Ajax.get("/checkout/reportCheck", params)
  },
  cashierCheck(params) {
    return Ajax.get("/checkout/cashierCheck", params)
  },
  assetsCheck(params) {
    return Ajax.get("/checkout/assetsCheck", params)
  },
  salaryCheck(params) {
    return Ajax.get("/checkout/salaryCheck", params)
  },
  invoiceCheck(params) {
    return Ajax.get("/checkout/invoiceCheck", params)
  },
  makeupDeficitCheck(params) {
    return Ajax.get("/checkout/makeupDeficitCheck", params)
  },
  brokenCheck(params) {
    return Ajax.get("/checkout/brokenCheck", params)
  },
  reviewedCheck(params) {
    return Ajax.get("/checkout/reviewedCheck", params)
  },
  profitCheck(year, month) {
    return Ajax.get("/checkout/profitCheck", {year, month})
  },
  exchangeCheck(year, month) {
    return Ajax.get("/checkout/exchange/check", {year, month})
  },
  getProfitVoucher(year, month) {
    return Ajax.get("/checkout/getProfitVoucher", {year, month})
  },
  invoicing(params) {
    return Ajax.get("/checkout/invoicing", params)
  },
  unCheck(params) {
    return Ajax.get("/checkout/unCheck", params)
  },
  templateList(year, month) {
    return Ajax.get("/checkout/template", {year, month})
  },
  templateShowData(checkYear, checkMonth) {
    return Ajax.get("/checkout/template/show/data", {checkYear, checkMonth})
  },
  loadTplData(params) {
    return Ajax.get("/checkout/template/data", params)
  },
  updateTplData(params) {
    return Ajax.get("/checkout/template/updateTplData", params)
  },
  beginCheck() {
    return Ajax.get("/checkout/begin/check")
  },
  saveCheckoutTemplate(params) {
    return Ajax.post("/checkout/template", params)
  },
  deleteTemplate(id) {
    return Ajax.delete("/checkout/template/" + id)
  },
  unCheckBatch(params) {
    return Ajax.get("/checkout/unCheckBatch", params)
  },
  batchCheckInvoicing(checkYear,checkMonth) {
    return Ajax.get("/checkout/batchCheckInvoicing", {checkYear,checkMonth})
  },
  endAdjustment(params,extend) {
    return Ajax.post("/checkout/endAdjustment", params, {params:extend})
  },
  batchCheckOld(params) {
    return Ajax.get("/checkout/batchCheckOld", params)
  },
}
